"use client";

import { Icon, Stack, SxProps, Tab, Tabs, Theme, Typography } from "@mui/material";
import React, { useState } from "react";
import { productsSearchParamsSchema, productsSearchParamsSchemaDefaults } from "./ProductsSearchParamsSchema";
import { useQueryParams } from "@/lib/useQueryParams";
import SortIcon from "@/app/_components/Icons/SortIcon";
import NextLink from "next/link";
import { useRouter } from "next/navigation";
import { useSiteSearchContext } from "./SiteSearchContext";

export default function SearchPageSortFilters({ sx }: { sx?: SxProps<Theme> | undefined }) {
  const { sortItems, totalProductsCount, activeSort, handleSortChange } = useSiteSearchContext();

  return (
    <Stack gap={1} direction={"row"} alignItems={"center"} sx={{ ...sx }}>
      <Icon sx={{ color: "grey.400", fontSize: 18 }}>
        <SortIcon />
      </Icon>
      <Typography variant="body2" sx={{ color: "grey.400", display: { xs: "none", md: "block" }, whiteSpace: "nowrap" }}>
        مرتب سازی بر اساس:
      </Typography>
      <Tabs
        value={activeSort}
        variant="scrollable"
        scrollButtons="auto"
        allowScrollButtonsMobile
        textColor="secondary"
        //@ts-ignore
        indicatorColor={"transparent"}
        sx={{ minHeight: 24 }}
      >
        {sortItems.map((item) => {
          return (
            <Tab
              key={item.value}
              value={item.value}
              // component={NextLink}
              onClick={(e) => {
                e.preventDefault();
                handleSortChange(item.value);
              }}
              // href={getPath({
              //   page: 1,
              //   sort: item.value,
              // })}
              sx={{ p: 1, minHeight: 24, minWidth: 36 }}
              label={item.name}
            />
          );
        })}
      </Tabs>
      <Typography variant="body2" sx={{ color: "grey.400", ml: "auto", display: { xs: "none", md: "block" }, whiteSpace: "nowrap" }}>
        {totalProductsCount.toLocaleString()} کالا
      </Typography>
    </Stack>
  );
}
